module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Print_16"],"path":[{"$":{"d":"M5,12h6v1H5ZM13,1H3V3H13Zm3,9H14v5H2V10H0V4H16Zm-3,0V8H3v6H13ZM5,11h6V10H5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Print_16.svg
// module id = 0EEM
// module chunks = 1